<template>
  <Teleport to="body">
    <div v-if="isOpen" class="explore-project" @click.self="closeModal">
      <div class="explore-project-overlay" @click.self="closeModal">
        <div class="explore-project__window">
          <button class="explore-project__close-btn" @click="closeModal">
            <img :src="require('@/assets/img/explore-project/close-icon.svg')" alt="close" />
          </button>

          <div class="explore-project__body">
            <iframe title="widget" :src="widgetUrl" width="100%" height="628px" frameborder="0" allowfullscreen webkitallowfullscreen mozallowfullscreen oallowfullscreen msallowfullscreen async />
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue';
import { widgetGalleryPlansIds } from '@/enums/widgetGalleryPlansIds';

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  selectedSubtitle: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['close']);

const widgetUrl = computed(() => {
  const widgetId = widgetGalleryPlansIds[props.selectedSubtitle];
  if (!widgetId) return '';
  return `${window.location.origin}/widget/?id=${widgetId}`;
});

const closeModal = () => {
  emit('close');
};
</script>
